import { Typography } from '@euler/app/components/typography';
import { ApdmImportSummary } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { useTheme } from 'styled-components';
import { routineCategoryLabel } from '../../functions/routineCategoryLabel';

const kShown = 5;

/** The maintenance the file shows most, by number of documents. */
export function RoutineBreakdown({
  routine,
}: {
  routine: ApdmImportSummary['routine'];
}) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  if (!routine.length) return null;
  return (
    <View style={{ marginTop: rpx(12) }}>
      <Typography.Text size={rpx(13)} bold color={theme.label.color}>
        主要保养项目
      </Typography.Text>
      {routine.slice(0, kShown).map(entry => (
        <Typography.Text
          key={entry.category}
          size={rpx(13)}
          color={theme.label.color}
        >
          {routineCategoryLabel(entry.category)} · {entry.documents} 单
        </Typography.Text>
      ))}
    </View>
  );
}
